import React from "react";

export default function Services() {
  return (
    <div className="text-center py-20">
      <h1 className="text-5xl font-bold text-[#8C1515]">
        No limits to your brand!
      </h1>
      <p className="text-gray-600 mt-4">
        Custom embroidery, screen printing & apparel branding.
      </p>
    </div>
  );
}